import React, { FunctionComponent, useMemo } from 'react';
import { Adult } from '@lt/components/icons-react/userflow';
import {
  AdultsCount,
  AdultsLabel,
  Wrapper,
  StyledPlus,
  AdultsWrapper,
  KidsCount,
  KidsLabel,
  StyledChild,
  KidsAgesList,
  AdultsAndKidsWrapper,
} from './SearchParamsTourists.style';
import { pluralizeYears } from '@lt/components/utils/pluralizeUtils';

type Props = {
  adultsCount: number;
  kidsCount: number;
  kidsAges: number[];
  parentWidth?: number;
};

export const SearchParamsTourists: FunctionComponent<Props> = ({
  adultsCount,
  kidsCount,
  kidsAges,
  parentWidth,
}) => {
  const kidsAgesWithPostfix = useMemo(
    () => kidsAges?.map((item) => `${item} ${pluralizeYears(item)}`).join(', '),
    [kidsAges]
  );
  return (
    <Wrapper parentWidth={parentWidth}>
      {(adultsCount > 0 || kidsCount > 0) && (
        <AdultsAndKidsWrapper>
          {adultsCount > 0 && (
            <AdultsWrapper>
              <AdultsCount>
                {adultsCount}
                <Adult width={16} height={30} />
                {kidsCount > 0 && (
                  <StyledPlus parentWidth={parentWidth} preserveAspectRatio="none" />
                )}
              </AdultsCount>
              <AdultsLabel parentWidth={parentWidth}>Взрослые</AdultsLabel>
            </AdultsWrapper>
          )}
          {kidsCount > 0 && (
            <div>
              <KidsCount>
                {kidsCount}
                <StyledChild />
              </KidsCount>
              <KidsLabel parentWidth={parentWidth}>Дети</KidsLabel>
            </div>
          )}
        </AdultsAndKidsWrapper>
      )}
      {kidsCount > 0 && (
        <KidsAgesList parentWidth={parentWidth}>{kidsAgesWithPostfix}</KidsAgesList>
      )}
    </Wrapper>
  );
};
